module.exports = __webpack_public_path__ + "img/dummyprod5@1x.014893ef.png";